import { useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router";

import "./App.scss";
import Header from "./components/organisms/Header/Header";
import Home from "./components/pages/Homepage/Home";
import About from "./components/pages/About/About";
import Contact from "./components/pages/Contact/Contact";
import Footer from "./components/organisms/Footer/Footer";
import SearchPage from "./components/pages/SearchPage/SearchPage";
import Login from "./components/pages/Login/Login";
import NotFound from "./components/pages/Errorpage/NotFound ";
import ForgetPassword from "./components/pages/ForgotPassword/ForgotPassword";
import ChangePassword from "./components/pages/ChangePassword/ChangePassword";
import ConfirmBooking from "./components/pages/Booking/Booking";
import Register from "./components/pages/Register/Register";
import Profile from "./components/pages/Profile/Profile";
import UpdateProfile from "./components/pages/Profile/UpdateProfile";
import BookingsHistory from "./components/pages/BookingsHistory/BookingsHistory";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import PrivacyPolicy from "./components/pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./components/pages/TermsAndConditions/TermsAndConditions";
import Image from "./components/atoms/Image/Image";
import commuteLoader from "./assets/images/commute_loader.gif";

import BookingResponse from "./components/pages/BookingResponse/BookingResponse";
import Cancellationpolicy from "./components/pages/Cancellationpolicy/Cancellationpolicy";
import RefundPolicy from "./components/pages/Refundpolicy/RefundPolicy";
import CarUpgradePolicy from "./components/pages/CarUpgradePolicy/CarUpgradePolicy";
// import CancelBookings from "./components/pages/CancelBooking/CancelBookings";
const routes = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "/search-result", element: <SearchPage /> },
  { path: "/login", element: <Login /> },
  { path: "/forget-password", element: <ForgetPassword /> },
  { path: "/change-password", element: <ChangePassword /> },
  { path: "/booking", element: <ConfirmBooking /> },
  { path: "/register", element: <Register /> },
  // { path: '/dashboard', element: <PrivateRoute element={<Dashboard />} /> },
  { path: "/profile", element: <PrivateRoute element={<Profile />} /> },
  {
    path: "/update-profile",
    element: <PrivateRoute element={<UpdateProfile />} />,
  },
  {
    path: "/bookings-history",
    element: <PrivateRoute element={<BookingsHistory />} />,
  },
  // {
  //   path: "/cancel-bookings",
  //   element: <PrivateRoute element={<CancelBookings />} />,
  // },

  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/terms-and-conditions", element: <TermsAndConditions /> },
  { path: "/cancellation-policy", element: <Cancellationpolicy /> },
  { path: "/refund-policy", element: <RefundPolicy /> },
  { path: "/car-upgrade-policy", element: <CarUpgradePolicy /> },


  { path: "/booking-response", element: <BookingResponse /> },
];
function App() {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsLoading(true);
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, [location]);
  return (
    <div id="wrapper">
      {isLoading ? (
        <>
          <div className="loader">
            <Image src={commuteLoader} alt="loader" />
          </div>
        </>
      ) : (
        <>
          <Header />
          <Routes>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>

          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
